<template>
  <div
    :id="playerWrapId"
    style="width:100%;height: calc(100vh - 70px - 60px - 40px);max-height: 500px"
  >  <volume
        :player="AliyunPlayer"
        style="display:inline-block;position: absolute;display: inline-block;right: 82px;top: 50%;transform: translateY(-36%);"
        ref="volume"
      ></volume></div>
</template>

<script>
import volume from "@/components/player_control/volume";

export default {
  name: "VideoPlayer",
  components: {
    volume
  },
  props: {
    playerWrapId: {
      type: String,
      default: "aliyunVideo"
    },
    playerConfig: {
      type: Object
    }
  },
  data() {
    return {
      AliyunPlayer: {}
    };
  },
  methods: {
    /***
     * activeVideoInfo: {
     * vid: string,
     * playauth: string
     *}
     */
    initAliyunPlayer(activeVideoInfo) {
      console.log(activeVideoInfo, "activeVideoInfo");

      if (!(activeVideoInfo instanceof Object)) {
        console.error("该函数接收一个对象作为参数");
        return;
      }
      let self = this;
      self.AliyunPlayer = new Aliplayer(
        Object.assign(
          {
            id: this.playerWrapId,
            width: "100%",
            height: "100%",
            autoplay: true,
            playsinline: true,
            useH5Prism: true,
            controlBarVisibility: "hover",
            // vid: self.play_vid,
            // playauth: self.play_auth,
            qualitySort: "desc",
            isLive: false,
            preload: true,
            definition: null,
            defaultDefinition: "HD",
            skinLayout: [
              { name: "bigPlayButton", align: "blabs", x: 30, y: 80 },
              { name: "errorDisplay", align: "tlabs", x: 0, y: 0 },
              { name: "infoDisplay", align: "cc" },
              {
                name: "controlBar",
                align: "blabs",
                x: 0,
                y: 0,
                children: [
                  { name: "progress", align: "blabs", x: 0, y: 44 },
                  { name: "fullScreenButton", align: "tr", x: 10, y: 10 },
                  { name: "setting", align: "tr", x: 15, y: 12 },
                  { name: "playButton", align: "tl", x: 15, y: 12 },
                  // { name: "volume", align: "tr", x: 5, y: 10 },
                  // { name: "timeDisplay", align: "tl", x: 10, y: 7 }
                ]
              }
            ]
          },
          activeVideoInfo
        )
      );
      self.insert_control();
      // self.videoShow = true;
      // this.$emit("videoShow", true)

      self.AliyunPlayer.on("ready", e => {
        if (
          document.querySelector(".prism-setting-item.prism-setting-audio") !=
          null
        )
          document.querySelector(
            ".prism-setting-item.prism-setting-audio"
          ).style.display = "none";
        if (
          document.querySelector(".prism-setting-item.prism-setting-cc") != null
        )
          document.querySelector(
            ".prism-setting-item.prism-setting-cc"
          ).style.display = "none";
        if (
          document.querySelector(".prism-setting-item.prism-setting-speed") !=
          null
        )
          document.querySelector(
            ".prism-setting-item.prism-setting-speed"
          ).style.display = "none";

        // console.info("ready");
        self.AliyunPlayerInterval = setInterval(() => {
          if (
            document.querySelector(".prism-big-play-btn.pause") != null &&
            document.querySelector(".prism-big-play-btn.pause").style.display ==
              "none"
          ) {
            document.querySelector(".prism-big-play-btn.pause").style.display =
              "block";
            // console.info("ready11111");
            clearInterval(self.AliyunPlayerInterval);
          }
        }, 50);
        if (this.$listeners.videoSnapShot) {
          let video = document.querySelector(`#${playerWrapId}`).children[0];
          console.log(video);
          this.$emit("videoSnapShot");
          this.dispose();
        }
        // this.AliyunPlayer.seek(2);
        // this.AliyunPlayer.pause();
      });

      self.AliyunPlayer.on("play", e => {
        clearInterval(self.AliyunPlayerInterval);
      });

      self.AliyunPlayer.on("error", e => {
        // self.videoActiveInfo.player_error_code = e.paramData.error_code;
      });
    },
    insert_control() {
      this.$nextTick(() => {
        const player_control = document.querySelector(".prism-controlbar");
        console.log(player_control);
        player_control.appendChild(this.$refs.volume.$el);
      });
    },
    dispose() {
      this.AliyunPlayer.dispose();
    }
  }
};
</script>

<style scoped lang="less">

/deep/ .el-slider.is-vertical .el-slider__runway{
  margin: 0;
}

/deep/ .prism-info-left-bottom {
  left: 63px !important;
  bottom: 23px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/video_player.vue